"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.HammeringOfDminaAbilityHandler = exports.HammeringOfDminaActorAbilityFactory = exports.HammeringOfDminaAbilityArgs = void 0;
const AbilityType_1 = require("../../core/abilities/AbilityType");
const AbilityDamage_1 = require("../../core/AbilityDamage");
const ActorAbilityState_1 = require("../../core/actors/ActorAbilityState");
const Duration_1 = require("../../core/Duration");
const Bleeding_1 = require("../../core/effects/core/Bleeding");
const Registries_1 = require("../../core/state/Registries");
const Target_1 = require("../../core/Target");
class HammeringOfDminaAbilityArgs {
    constructor(target) {
        this.target = target;
        this.__type = AbilityType_1.AbilityType.HammeringOfDmina;
        this.__typeName = "HammeringOfDmina";
    }
}
exports.HammeringOfDminaAbilityArgs = HammeringOfDminaAbilityArgs;
let HammeringOfDminaActorAbilityFactory = class HammeringOfDminaActorAbilityFactory {
    mk() {
        return new ActorAbilityState_1.ActorAbilityState("HammeringOfDmina", "AllEnemies", 3);
    }
};
HammeringOfDminaActorAbilityFactory = __decorate([
    Registries_1.ActorAbilities.register("HammeringOfDmina")
], HammeringOfDminaActorAbilityFactory);
exports.HammeringOfDminaActorAbilityFactory = HammeringOfDminaActorAbilityFactory;
let HammeringOfDminaAbilityHandler = class HammeringOfDminaAbilityHandler {
    init(sequence, container, actorId) { }
    activate(sequence, container, ability) {
        container.applyMultiAttack({
            sequence,
            abilityKey: ability.args.__typeName,
            attackType: "melee",
            attackerId: ability.invokerId,
            targets: container.selectLivingTargets(ability.invokerId, Target_1.Target.AllEnemies)
                .map((targetId) => ({
                damages: [
                    AbilityDamage_1.AbilityDamage.Power("Physical", 70)
                ],
                targetId,
                effects: [
                    {
                        targetId,
                        effect: new Bleeding_1.BleedingEffectArgs("Power", 10),
                        duration: Duration_1.Duration.Turns(4)
                    }
                ]
            }))
        });
    }
};
HammeringOfDminaAbilityHandler = __decorate([
    Registries_1.Abilities.register(AbilityType_1.AbilityType.HammeringOfDmina)
], HammeringOfDminaAbilityHandler);
exports.HammeringOfDminaAbilityHandler = HammeringOfDminaAbilityHandler;
